import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Typography } from '@optimus-web/core';
import { OrderItem, ApplicationState, WithServiceId, WithTimeUnit } from '@mews-commander/types';
import { ConvertedCurrencyValue, LocalizedUtcTimeUnit, LocalizedUtcTimeUnitFormat } from '@mews-commander/ui';
import { getTimeUnitByServiceId } from '@mews-commander/legacy-entities/src/ducks/services';
import { Table } from '@mews-commander/ui/legacy';
import { PartialMonthDayRange } from '../../ItemsTab/PartialMonthDayRange';

interface OwnProps extends WithServiceId {
    nights: OrderItem[];
    isMultiTaxEnvironment: boolean;
}

type Props = OwnProps & WithTimeUnit;

const DefaultProductOrderItemsList = ({ nights, isMultiTaxEnvironment, timeUnit }: Props) => {
    const mapping = [
        {
            valueKey: 'start',
            render: ({ startUtc, proRataStartUtc, proRataEndUtc }: OrderItem) => {
                if (proRataStartUtc && proRataEndUtc) {
                    return (
                        <Typography textStyle="bodyMediumStrong" variant="secondary" as="div">
                            <PartialMonthDayRange proRataStartUtc={proRataStartUtc} proRataEndUtc={proRataEndUtc} />
                        </Typography>
                    );
                }

                if (startUtc) {
                    return (
                        <Typography textStyle="bodyMediumStrong" variant="secondary" as="div">
                            <LocalizedUtcTimeUnit
                                format={LocalizedUtcTimeUnitFormat.Short}
                                timeUnit={timeUnit}
                                utcString={startUtc}
                            />
                        </Typography>
                    );
                }
            },
        },
        {
            valueKey: 'amount',
            render: ({ totalAmount }: OrderItem) => (
                <ConvertedCurrencyValue amount={totalAmount} net={isMultiTaxEnvironment} />
            ),
            columnAlignment: 'right',
        },
    ];

    return <Table mapping={mapping} source={nights} headerless />;
};

export default connect(
    createStructuredSelector<ApplicationState, OwnProps, WithTimeUnit>({
        timeUnit: getTimeUnitByServiceId,
    })
)(DefaultProductOrderItemsList);
